

//solo lo usaremos aqui
export class DetallePetcicion {
  tipo: string = "";
  id: number = 0;
  fechaPet: string = "";
  titular: string = "";
  tel: string = "";
  provincia: string = "";
  cia: string = "";
  email: string = "";
  siniestro: string = "";
  matricula: string = "";
  servicio: string = "";
  tipoServicio: string = "";
  marca: string = "";
  modelo: string = "";
  taller: number | string = 0;
  observaciones: string = "";
  estado: string = "";
  poliza: string = "";
  id_piloto: string = "";
  ia: string = "";
  empresa: number | string = 0;
  fecha: string = "";
  agente: string = "";
  num_cia: string = "";

  constructor() { }
  private formatearFecha(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // getMonth() es 0-index
    const año = fecha.getFullYear();
    const horas = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');
    const segundos = fecha.getSeconds().toString().padStart(2, '0');

    return `${dia}/${mes}/${año} ${horas}:${minutos}:${segundos}`;
  }
  public convertirDesdeWebNew(pWeb: any): void {
    let fecha = new Date(pWeb[0].created);
    this.id = pWeb[0].id?pWeb[0].id:"";
    this.fechaPet = this.formatearFecha(fecha);
    this.fecha = pWeb[0].created;
    this.titular = pWeb[0].nombre?pWeb[0].nombre.toString().trim().toUpperCase():"";
    this.tel = pWeb[0].telefono?pWeb[0].telefono.toString().trim().toUpperCase():"";
    this.provincia = "";
    this.cia = pWeb[0].cia?pWeb[0].cia.toString().trim().toUpperCase():"";
    this.email = pWeb[0].email?pWeb[0].email.toString().trim().toUpperCase():"";
    this.siniestro = pWeb.siniestro?pWeb.siniestro.toString().trim().toUpperCase():"";
    this.matricula = pWeb[0].matricula?pWeb[0].matricula.toString().trim().toUpperCase():"";
    this.servicio = "";
    this.tipoServicio = pWeb[0].luna_afectada?pWeb[0].luna_afectada.toString().trim():"" + " " +  pWeb[0].damage_side?pWeb[0].damage_side.toString().trim():"" + " "
      + pWeb[0].damage_area?pWeb[0].damage_area.toString().trim():"";
    this.tipoServicio = this.tipoServicio.toString().toUpperCase();
    this.marca = pWeb[0].marca?pWeb[0].marca.toString().trim().toUpperCase():"";
    this.modelo = pWeb[0].modelo?pWeb[0].modelo.toString().trim().toUpperCase():"";
    if (pWeb[0].taller && (pWeb[0].taller.toString().trim() != '')){
      this.taller = pWeb[0].taller.toString().trim().toUpperCase();
    }else if (pWeb[0].empresa){
      this.taller = pWeb[0].empresa.toString().trim().toUpperCase();
    }else {
      this.taller = "";
    }
    this.observaciones = pWeb[0].other_damage_area?pWeb[0].other_damage_area.toString().trim():"" + " " + pWeb[0].fecha_cita?pWeb[0].fecha_cita.toString().trim():"" + " "
      + pWeb[0].codigo_cita?pWeb[0].codigo_cita.toString().trim():"" + " " + this.cia + " " + pWeb[0].damage_type?pWeb[0].damage_type.toString().trim():"" + " "
      + pWeb[0].tipo_vehiculo?pWeb[0].tipo_vehiculo.toString().trim():"" + " " + pWeb[0].es_persona_riesgo?pWeb[0].es_persona_riesgo.toString().trim():"" + " " + pWeb[0].estado_contact?pWeb[0].estado_contact.toString().trim():"";
    this.observaciones = this.observaciones.toString().toUpperCase();
    this.estado = this.convertirEstadoContact(pWeb[0].estado_contact);
    this.ia = pWeb[0].glass_treatment?pWeb[0].glass_treatment.toString().trim().toUpperCase():"";

  }

  public convertirRauda(pWeb: any){
    let fecha = new Date(pWeb[0].created);
    this.id = pWeb[0].id?pWeb[0].id:"";
    this.fechaPet = this.formatearFecha(fecha);
    this.fecha = pWeb[0].created;
    this.titular = pWeb[0].nombre?pWeb[0].nombre.toString().trim().toUpperCase():"";
    this.tel = pWeb[0].telefono?pWeb[0].telefono.toString().trim().toUpperCase():"";
    this.provincia = "";
    this.cia = pWeb[0].cia?pWeb[0].cia.toString().trim().toUpperCase():"";
    this.email = pWeb[0].email?pWeb[0].email.toString().trim().toUpperCase():"";
    this.siniestro = pWeb.siniestro?pWeb.siniestro.toString().trim().toUpperCase():"";
    this.matricula = pWeb[0].matricula?pWeb[0].matricula.toString().trim().toUpperCase():"";
    this.servicio = "";
    this.tipoServicio = pWeb[0].trabajo_realizar?pWeb[0].trabajo_realizar.toString().trim():"";
    this.marca = pWeb[0].marca?pWeb[0].marca.toString().trim().toUpperCase():"";
    this.modelo = pWeb[0].modelo?pWeb[0].modelo.toString().trim().toUpperCase():"";
    if (pWeb[0].taller && (pWeb[0].taller.toString().trim() != '')){
      this.taller = pWeb[0].taller.toString().trim().toUpperCase();
    }else if (pWeb[0].empresa){
      this.taller = pWeb[0].empresa.toString().trim().toUpperCase();
    }else {
      this.taller = "";
    }
    this.observaciones = pWeb[0].id_piloto.toString().trim().toUpperCase();
    this.estado = this.convertirEstadoContact(pWeb[0].estado_contact);
  }

  public convertirDesdeWebNewElse(pWeb: any): void {
    let fecha = new Date(pWeb[0].created);
    this.id = pWeb[0].id?pWeb[0].id:"";
    this.fechaPet = this.formatearFecha(fecha);
    this.fecha = pWeb[0].created;
    this.titular = pWeb[0].nombre?pWeb[0].nombre.toString().trim().toUpperCase():"";
    this.tel = pWeb[0].telefono?pWeb[0].telefono.toString().trim().toUpperCase():"";
    this.provincia = "";
    this.cia = pWeb[0].cia?pWeb[0].cia.toString().trim().toUpperCase():"";
    this.email = pWeb[0].email?pWeb[0].email.toString().trim().toUpperCase():"";
    this.siniestro = pWeb.siniestro?pWeb.siniestro.toString().trim().toUpperCase():"";
    this.matricula = pWeb[0].matricula?pWeb[0].matricula.toString().trim().toUpperCase():"";
    this.servicio = "";
    this.tipoServicio = "";
    this.marca = pWeb[0].marca?pWeb[0].marca.toString().trim().toUpperCase():"";
    this.modelo = pWeb[0].modelo?pWeb[0].modelo.toString().trim().toUpperCase():"";
    this.taller = pWeb[0].empresa?pWeb[0].empresa.toString().trim().toUpperCase():"";
    let codigo = pWeb[0].cpost?pWeb[0].cpost.toString().trim().toUpperCase():"";
    let contacto= pWeb[0].metodo_contacto?pWeb[0].metodo_contacto.toString().trim().toUpperCase(): "";
    let tvehiculo = pWeb[0].tipo_vehiculo?pWeb[0].tipo_vehiculo.toString().trim().toUpperCase():"";
    let calendari = pWeb[0].calendario?pWeb[0].calendario.toString().trim().toUpperCase():"";
    let damage= pWeb[0].damage_type?pWeb[0].damage_type.toString().trim().toUpperCase():"";
    let campana = pWeb[0].campana?pWeb[0].campana.toString().trim().toUpperCase():"";
    let glass_type = pWeb[0].glass_type?pWeb[0].glass_type.toString().trim().toUpperCase():"";
    let comment = pWeb[0].comment?pWeb[0].comment.toString().trim().toUpperCase():"";
    let tipo = pWeb[0].tipo?pWeb[0].tipo.toString().trim().toUpperCase():"";
    let slug = pWeb[0].slug?pWeb[0].slug.toString().trim().toUpperCase():"";
    let lead = pWeb[0].lead?pWeb[0].lead.toString().trim().toUpperCase():"";
    let tcampana = pWeb[0].titulocampaya?pWeb[0].titulocampaya.toString().trim().toUpperCase():"";
    let motivoc = pWeb[0].motivo_contacto?pWeb[0].motivo_contacto.toString().trim().toUpperCase():"";
    this.observaciones = codigo + " " + contacto + " "
      + tvehiculo + " " + calendari + " " + damage + " "
      + motivoc + " " + campana + " " + glass_type + " "
      + comment + " " + tipo + " " + slug + " "
      + lead + " " + tcampana;
    this.observaciones = this.observaciones.toString().toUpperCase();
    this.estado = this.convertirEstadoContact(pWeb[0].estado_contact);
    this.id_piloto = pWeb[0].id_piloto?pWeb[0].id_piloto.toString().trim():""
  }
  convertirDesdeWeb(pWeb: any) {
    let fecha = new Date(pWeb[0].created);
    this.id = pWeb[0].id?pWeb[0].id:"";
    this.fechaPet = this.formatearFecha(fecha);
    this.fecha = pWeb[0].created;
    this.titular = pWeb[0].nomcli?pWeb[0].nomcli.toString().trim().toUpperCase():"";
    this.tel = pWeb[0].telefono?pWeb[0].telefono.toString().trim().toUpperCase():"";
    this.provincia = pWeb[0].provincia?pWeb[0].provincia.toString().trim().toUpperCase():"";
    this.cia = "";
    this.email = pWeb[0].email?pWeb[0].email.toString().trim().toUpperCase():"";
    this.siniestro = pWeb.siniestro?pWeb.siniestro.toString().trim().toUpperCase():"";
    this.matricula = pWeb[0].matricula?pWeb[0].matricula.toString().trim().toUpperCase():"";
    this.servicio = pWeb[0].servicio?pWeb[0].servicio.toString().trim().toUpperCase():"";
    this.tipoServicio = pWeb[0].servicio?pWeb[0].servicio.toString().trim().toUpperCase():"";
    this.marca = pWeb[0].marca?pWeb[0].marca.toString().trim().toUpperCase():"";
    this.modelo = pWeb[0].modelo?pWeb[0].modelo.toString().trim().toUpperCase():"";
    if (pWeb[0].taller && (pWeb[0].taller.toString().trim() != '')){
      this.taller = pWeb[0].taller.toString().trim().toUpperCase();
    }else if (pWeb[0].empresa){
      this.taller = pWeb[0].empresa.toString().trim().toUpperCase();
    }else {
      this.taller = "";
    }
    this.observaciones = pWeb[0].obser?pWeb[0].obser.toString().trim().toUpperCase():"";
    this.estado = this.convertirEstadoContact(pWeb[0].par1.toString().trim());

  }


  public convertirDesdeOutbound(pOutbound: any): void {
    let fecha = new Date(pOutbound[0].created);
    this.id = pOutbound[0].id?pOutbound[0].id:"";
    this.fechaPet = this.formatearFecha(fecha);
    this.fecha = pOutbound[0].created;
    this.titular = pOutbound[0].nombre?pOutbound[0].nombre.toString().trim().toUpperCase():"";
    this.tel = pOutbound[0].telefono_contacto?pOutbound[0].telefono_contacto.toString().trim().toUpperCase():"";
    this.provincia = "";
    this.cia = pOutbound[0].cia?pOutbound[0].cia.toString().trim().toUpperCase():"";
    this.email = "";
    this.siniestro = "";
    this.matricula = pOutbound[0].matricula?pOutbound[0].matricula.toString().trim().toUpperCase():"";
    this.servicio = "";
    this.tipoServicio = ""; //REVISAR
    this.marca = pOutbound[0].marca?pOutbound[0].marca.toString().trim().toUpperCase():"";
    this.modelo = pOutbound[0].modelo?pOutbound[0].modelo.toString().trim().toUpperCase():"";
    this.taller = "";
    this.observaciones = pOutbound[0].piloto?pOutbound[0].piloto.toString().trim().toUpperCase():"";
    this.estado = this.convertirEstadoContact(pOutbound[0].estado);
  }

  public convertirDesdeSegurCaixa(segu: any): void {
    let fecha = new Date(segu[0].created);
    this.id = segu[0].id?segu[0].id:"";
    this.fechaPet = this.formatearFecha(fecha);
    this.fecha = segu[0].created;
    this.titular = "";
    this.tel = segu[0].telefono?segu[0].telefono.toString().trim().toUpperCase():"";
    this.provincia = "";
    this.cia = "";
    this.email = "";
    this.siniestro = segu[0].expediente?segu[0].expediente.toString().trim().toUpperCase():"";
    this.matricula = segu[0].matricula?segu[0].matricula.toString().trim().toUpperCase():"";
    this.servicio = "";
    this.tipoServicio = ""; //REVISAR
    this.marca = "";
    this.modelo = "";
    this.taller = "";
    this.poliza = segu[0].poliza?segu[0].poliza.toString().trim().toUpperCase():"";
    this.observaciones = segu[0].descripcion?segu[0].descripcion.toString().trim().toUpperCase():"";
    this.estado = this.convertirEstadoContact(segu[0].estado_contact);
  }

  public convertirTUVOZ(res: any){
    let fecha = new Date(res[0].fecha);
    this.id = res[0].pet?res[0].pet:"";
    this.fechaPet = this.formatearFecha(fecha);
    this.fecha = res[0].fecha.toString().trim().toUpperCase();
    this.titular = res[0].titular.toString().trim().toUpperCase();
    this.tel = res[0].telf1?res[0].telf1.toString().trim().toUpperCase():"";
    this.provincia = res[0].provincia?res[0].provincia.toString().trim().toUpperCase():"";
    this.cia = res[0].cia?res[0].cia.toString().trim().toUpperCase():"";
    this.email = "";
    this.siniestro = "";
    this.matricula = res[0].matricula?res[0].matricula.toString().trim().toUpperCase():"";
    this.servicio = res[0].servicio?res[0].servicio.toString().trim().toUpperCase():"";
    this.tipoServicio = ""; //REVISAR
    this.marca = "";
    this.modelo = "";
    this.taller = res[0].taller?res[0].taller.toString().trim().toUpperCase():"";
    this.poliza = "";
    this.observaciones = res[0].observa?res[0].observa.toString().trim().toUpperCase():"";
    this.estado = this.convertirEstadoContact(res[0].par_001);
  }

  public convertirCorredores(res: any){
    let fecha = new Date(res[0].fecha);
    this.id = res[0].id?res[0].id:"";
    this.fechaPet = this.formatearFecha(fecha);
    this.fecha = res[0].fecha;
    this.titular = res[0].asegurado.toString().trim().toUpperCase();
    this.tel = res[0].telefono?res[0].telefono.toString().trim().toUpperCase():"";
    this.provincia = res[0].provincia?res[0].provincia.toString().trim().toUpperCase():"";
    this.cia = res[0].cia?res[0].cia.toString().trim().toUpperCase():"";
    this.email = "";
    this.siniestro = "";
    this.matricula = res[0].matricula?res[0].matricula.toString().trim().toUpperCase():"";
    this.servicio = res[0].servicio?res[0].servicio.toString().trim().toUpperCase():"";
    this.tipoServicio = ""; //REVISAR
    this.marca = "";
    this.modelo = "";
    this.taller = res[0].taller?res[0].taller.toString().trim().toUpperCase():"";
    this.poliza = "";
    this.observaciones = res[0].obser?res[0].obser.toString().trim().toUpperCase():"";
    this.agente =  res[0].agente?res[0].agente.toString().trim().toUpperCase():"";
    this.estado = this.convertirEstadoContact(res[0].par1);
  }

  private convertirEstadoContact(numeroEstado: number | string): string {
    /*
      0 => Pendiente  => P
      1 => Gestionada => G
      2 => Rellamada  => R
    */
    switch (numeroEstado) {
      case 0:
      case "0":
        return "p";
      case 1:
      case "1":
        return "g";
      case 2:
      case "2":
        return "r";
      default: break;
    }
    return "";
  }

  public convertirEstadoUpdate(letraEstado: string): string {
    /*
      0 => Pendiente  => P
      1 => Gestionada => G
      2 => Rellamada  => R
    */
    switch (letraEstado) {
      case "p":
        return "0";
      case "g":
        return "1";
      case "r":
        return "2";
      default: break;
    }
    return "";
  }
}
